module.exports = __webpack_public_path__ + "assets/img/48497d56702c0b8a39016ab21af83c1d.png";